// eslint-disable-next-line no-undef
const AppConfigJson = window.config;

AppConfigJson.Network.AppBaseUrl = `${document.location.protocol}//${document.location.host}`;
AppConfigJson.Environment.IsProd = AppConfigJson.Environment.Code === "prod";

export default AppConfigJson;
